const getDefaultState = () => {
  return {
    nomeVivaioEsclusioni: "",
    cognomeVivaioEsclusioni: "",
    idSocietaVivaioEsclusioni: null,
    societaDenominazioneVivaioEsclusioni: null,

    rowsToSkipVivaioEsclusioni: 0,
    fetchRowsVivaioEsclusioni: 25,
    currentPageVivaioEsclusioni: 1,
    sortColumnVivaioEsclusioni: "cognome",
    sortOrderVivaioEsclusioni: "asc",
  };
};
const state = getDefaultState();

const getters = {
  nomeVivaioEsclusioni: (state) => state.nomeVivaioEsclusioni,
  cognomeVivaioEsclusioni: (state) => state.cognomeVivaioEsclusioni,
  idSocietaVivaioEsclusioni: (state) => state.idSocietaVivaioEsclusioni,
  societaDenominazioneVivaioEsclusioni: (state) =>
    state.societaDenominazioneVivaioEsclusioni,

  rowsToSkipVivaioEsclusioni: (state) => state.rowsToSkipVivaioEsclusioni,
  fetchRowsVivaioEsclusioni: (state) => state.fetchRowsVivaioEsclusioni,
  currentPageVivaioEsclusioni: (state) => state.currentPageVivaioEsclusioni,
  sortColumnVivaioEsclusioni: (state) => state.sortColumnVivaioEsclusioni,
  sortOrderVivaioEsclusioni: (state) => state.sortOrderVivaioEsclusioni,
};

// const actions = {};
const mutations = {
  setnomeVivaioEsclusioni: (state, value) => {
    state.nomeVivaioEsclusioni = value;
  },
  setCognomeVivaioEsclusioni: (state, value) => {
    state.cognomeVivaioEsclusioni = value;
  },
  setsocietaDenominazioneVivaioEsclusioni: (state, value) => {
    state.societaDenominazioneVivaioEsclusioni = value;
  },
  setidSocietaVivaioEsclusioni: (state, value) => {
    state.idSocietaVivaioEsclusioni = value;
  },

  setFetchRowsVivaioEsclusioni: (state, value) => {
    state.currentPageVivaioEsclusioni = 1;
    state.rowsToSkipVivaioEsclusioni = 0;
    state.fetchRowsVivaioEsclusioni = value;
  },
  setCurrentPageVivaioEsclusioni: (state, value) => {
    state.currentPageVivaioEsclusioni = value;
    state.rowsToSkipVivaioEsclusioni = parseInt(
      (state.currentPageVivaioEsclusioni - 1) * state.fetchRowsVivaioEsclusioni
    );
  },
  setSortColumnVivaioEsclusioni: (state, value) => {
    state.sortColumnVivaioEsclusioni = value;
  },
  setSortOrderVivaioEsclusioni: (state, value) => {
    state.sortOrderVivaioEsclusioni = value;
  },
  resetFiltersVivaioEsclusioni: (state) => {
    Object.assign(state, getDefaultState());
  },
  setrowsToSkipVivaioEsclusioni: (state) => {
    state.currentPageVivaioEsclusioni = 1;
    state.rowsToSkipVivaioEsclusioni = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
